module.exports = __webpack_public_path__ + "static/media/sortbyarrows.0cf3deb8.svg";